import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../ui/datatable/DataTable";
import { TableWork } from "../../../../ui"
import "../unitofficer.css";
import { BASE_URLS, DOWNLOAD, NO_RECORDS_FOUND, PLATFORM_TYPE } from "../../../../constants/constants";
import {
  useGetEpbCountDetailsMutation,
  useGetEpbDetailsByBatchesMutation,
} from "../../../../services/finalizeGenerateViewTransmitService";
import CustomModal from "../../../../library/components/Modal/modal";
import { useDownloadEpbMutation, useGetEpbBallotUpdatedMutation } from "../../../../services/finalizeGenerateViewTransmitService";
import { parseJwt } from "../../../utilities/utils";
import axios from "axios";
import { useDispatch } from "react-redux";
import { showDownloader } from "../../../../features/downloader/downloader";
import { showPercentage } from "../../../../features/downloader/downloader";
import { ALERT_TYPE_ERROR,ALERT_TYPE_INFO } from '../../../../constants/constants';
import { createAlert } from '../../../../features/alert/alerts'
import moment from "moment";

const columns = [
  {
    Header: "S. No.",
    accessor: "S_No",
  },
  {
    Header: "State",
    accessor: "State",
  },
  {
    Header: "Phase No",
    accessor: "Phase No",
  },
  {
    Header: "Start Date & Time",
    accessor: "Start Date & Time",
  },
  {
    Header:  "End Date & Time",
    accessor: "End Date & Time",
  },
  {
    Header:   "Cutoff Date & Time",
    accessor: "Cutoff Date & Time",
  },
  {
    Header:   "Total e-PB",
    accessor: "Total e-PB",
  },
  {
    Header:   "Total e-PB Downloaded",
    accessor: "Total e-PB Downloaded",
  },
  {
    Header: "Action",
    accessor: "Action",
  },
];
const batchcolumns = [
  {
    Header: "e-PB",
    accessor: "e-Pb",
  },
  {
    Header: "Action",
    accessor: "Action",
  },
  {
    Header: "Last Download Date & Time",
    accessor: "Last Download Date & Time",
  },
];

const batchHeader = ["e-PB", "Action", "Last Download Date & Time"];

const GeneralElectionToAssemblyConstituency = ({ constType, electType }) => {
  const [epbBallotUnitData ,setepbBallotUnitData] = useState([]);
  const [epbbatchData, setepbbatchData] = useState([]);
  const [show, setShow] = useState(false);
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [Epbdata, datap] = useGetEpbCountDetailsMutation();
  const [getBatchData, datac] = useGetEpbDetailsByBatchesMutation();
  const [isUpdated, dataU] = useGetEpbBallotUpdatedMutation()
  const [startDate,setStartDate]=useState("")
  const [endDate,setEndDate]=useState("")
  const [stateCd,setStateCd]=useState("")
  const officerId = parseJwt(localStorage.access_token)?.preferred_username;
  const dispatch = useDispatch();
  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: 'Reject',
      }),
    )
  }
  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };

  const getballot = async (data,i,lengthItem) => {
    dispatch(showDownloader({ isdownloading: true }));
    const result = await axios({
      url: `${BASE_URLS.BALLOT_BASE_URL}api/v1/epb-data/download-epb`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        constType: data.constType,
        authorization: `Bearer ${localStorage.access_token}`,
        currentRole: localStorage.userrole,
        constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0],
        atkn_bnd: localStorage?.atkn_bnd,
      rtkn_bnd: localStorage?.rtkn_bnd,
      channelidobo: "ETPBMS",    
      "PLATFORM-TYPE":PLATFORM_TYPE
      },
      data: data,
      responseType: "blob",
      onDownloadProgress: (progressEvent) => {
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        dispatch(showPercentage({ percentage: percentCompleted }));
      },
    })
      .then((response) => {
        console.log(response,"firstresponse")
        var cd = new Date();
        var currentDate=cd.getFullYear()+"-"+("0"+(cd.getDate())).slice(-2)+"-"+("0"+(cd.getMonth()+1)).slice(-2)+"-"+("0"+cd.getHours()).slice(-2)+("0"+cd.getMinutes()).slice(-2)+("0"+cd.getSeconds()).slice(-2);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `S${startDate}_E${endDate}_${i+1}of${lengthItem}_${stateCd}_e-PB_${(parseJwt(localStorage?.access_token)?.preferred_username).toUpperCase()}_${constType}_${currentDate}.zip`);
        document.body.appendChild(link);
        link.click();
      })
      .then((response) => {
        console.log(response,"2ndresponse")
        setTimeout(() => {
          dispatch(showDownloader({ isdownloading: false }));
          dispatch(showPercentage({ percentage: 0 }));
          isUpdated({
            id: data?.id,
            electionType: data?.electionType,
            constType
          })
          // setShow(false);
        }, 2000);
      })
      .catch((error)=>{
        console.log(error,"exception")
        dispatch(showDownloader({ isdownloading: false }));
        dispatch(showPercentage({ percentage: 0 }));
        onInfo("Something went wrong Please try again")
      })
  };

  useEffect(()=>{
    if(dataU.isSuccess){
      Epbdata({
        constType: constType,
        electionType: electType,
        officerId: parseJwt(localStorage.access_token)?.preferred_username,
      });
    }
  },[dataU.isSuccess])

  useEffect(() => {
    if (datac.isSuccess) {
      let index = 0;
      const epbbatch = [];
      datac?.data?.payload?.map((item, i) => {
        epbbatch.push({
          // "e-Pb": `${(item.subSets?.length * i )+ 1} - ${(item.subSets?.length * i )+ 3}`,
          "e-Pb": `${index + 1} ${
            item.subSets.length === 1
              ? ""
              : " - " + (index = index + item.subSets?.length)
          }`,
          action: (
            <Link
              className="download-link"
              to={" "}
              onClick={
                () =>
                  getballot({
                    id: item.subSets,
                    isDummy: "false",
                    constType: constType,
                    electionType: electType,
                    officerId: officerId,
                  },i,datac?.data?.payload?.length)
              }
            >
              <i class="fa-solid fa-download mr-2"></i>
              {DOWNLOAD}
            </Link>
          ),
          downloadTime: (item?.downloadEpbTime===""||item?.downloadEpbTime===null||item?.downloadEpbTime===undefined)?"Yet to be Downloaded":moment(getDateTime(item.downloadEpbTime)).format(
            'DD-MMMM-YYYY HH:mm A',
          )
        });
      });
      setepbbatchData(epbbatch);
      setShow(true);
    }
  }, [datac.isSuccess]);

  useEffect(() => {
    Epbdata({
      constType: constType,
      electionType: electType,
      officerId: parseJwt(localStorage.access_token)?.preferred_username,
    });
  }, [constType, electType]);

  const getDate = (date) => {
    var result = date.split("-");
    return new Date(
      parseInt(result[2], 10),
      parseInt(result[1], 10) - 1,
      parseInt(result[0], 10)
    );
  };

  const getDateTime=(date)=>{
    let splittedDateTime=date.split(' ')
    let sDate=splittedDateTime[0].split('-')
    return sDate[2]+'-'+sDate[1]+'-'+sDate[0]+' '+splittedDateTime[1]
  }

 useEffect(()=>{
  const epbballotDownloadData = []
  if(datap.isSuccess){
    datap?.data?.payload?.map((item, i) => {
      let startDate = moment(getDateTime(item.startDateTime)).format(
        'MM-DD-YYYY HH:mm:ss',
      )
      let endDate = moment(getDateTime(item.endDateTime)).format(
        'MM-DD-YYYY HH:mm:ss',
      )
      // let currDate = moment(new Date()).format('MM-DD-YYYY HH:mm:ss');
      let currDate = moment(getDateTime(datap?.data?.serverDateTime)).format('MM-DD-YYYY HH:mm:ss');
  
  
      if (currDate <= endDate) {
        epbballotDownloadData.push({
          "S_No": i + 1,
          State: item.stateName,
          "Phase No": item.statePhaseNo,
          "Start Date & Time":moment(getDateTime(item.startDateTime)).format(
            'DD-MMMM-YYYY HH:mm A',
          ),
          "End Date & Time":moment(getDateTime(item.endDateTime)).format(
            'DD-MMMM-YYYY HH:mm A',
          ),
          "Cutoff Date & Time": moment(getDateTime(item.cutOffDateTime)).format(
            'DD-MMMM-YYYY HH:mm A',
          ),
          "Total e-PB": item.totalCount,
          "Total e-PB Downloaded": item.totalDownLoadedCount,
         Action:
            currDate < startDate ? (
              `The Downloading will start on ${moment(getDateTime(item.startDateTime)).format(
                'DD-MMMM-YYYY HH:mm A',
              )}`
            ) : (
              <Link
                className="download-link"
                to={" "}
                onClick={() =>
         {         getBatchData({
                    constType: constType,
                    electionType: electType,
                    officerId: parseJwt(localStorage.access_token)
                      ?.preferred_username,
                    isDummy: "false",
                    stateCd: item.stateCd,
                    statePhaseNo: item.statePhaseNo,
                    startDate:moment(getDateTime(item.startDateTime)).format(
                      'YYYY-MM-DD HH:mm:ss',
                    ),
                  });
                setStartDate(((item.startDateTime).replace(/-/g,'')).split(' ')[0])
                setEndDate(((item.endDateTime).replace(/-/g,'')).split(' ')[0])
                setStateCd(item.stateCd)
                }
                }
              >
                <i class="fa-solid fa-download mr-2"></i>
                {DOWNLOAD}
              </Link>
            ),
        });
      }
    });
    setepbBallotUnitData(epbballotDownloadData)
    setTotalNoOfRecords(datap?.data?.payload?.length)
  }
 },[datap.isSuccess])
  const onClose = () => {
    setShow(false);
  };

  return (
    <>
      <div>
        <CustomModal
          className="confirmation_modal"
          show={show}
          onClose={onClose}
          size="500px"
          closeIcon={true}
          modalTitle={"Download e-PB"}
          children={
            <TableWork
              id="UserList"
              theadData={batchHeader}
              tbodyData={epbbatchData}
              anchorTagName=""
              anchorTagclassName="viewDetails"
              emptyMessage="No data found"
              pageSize={8}
              pagination={true}
              paginationClass={"text-right p-0"}
            />
          }
        ></CustomModal>
          <Table
            placeholder="Search"
            globalsearch={true}
            selectall={true}
            columns={columns}
            emptyMessage="No Record Found"
            data={epbBallotUnitData?.length === 0 ? [] : epbBallotUnitData}
            size={10}
            tableClassNameCheck="contenttable-eroll"
            pagination
            records
            gotopage
            rows
            numberrows={totalNoOfRecords}
          />
      </div>
    </>
  );
};

export default GeneralElectionToAssemblyConstituency;
